module.exports = __webpack_public_path__ + "img/logo.f90673da.png";